var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 896 896",
    style: {
      enableBackground: "new 0 0 896 896"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_496",
    className: "st0",
    d: "M684.9-0.5H210.1C93.3-0.5-1,93.8-1,210.6v474.8c0,116.4,94.3,211.1,211.1,211.1l0,0h474.8 c116.4,0,211.1-94.3,211.1-211.1l0,0V210.6C896,93.8,801.3-0.5,684.9-0.5z M298.1,740H185.9V329h112.2L298.1,740L298.1,740z  M241.8,281.5c-36.7,0.4-66.3-28.8-66.8-65.1c0-36.7,29.2-66.3,65.5-66.8c36.3,0,66.3,29.2,66.8,65.5v0.4 C307.3,251.9,277.7,281.5,241.8,281.5C241.4,281.5,241.4,281.5,241.8,281.5L241.8,281.5z M746.6,487.6L746.2,740H634.4V530.6 c0-126-149.4-116-149.4,0V740H372.8V329h111.8v66c41.7-66.8,129.3-86.8,195.7-45.5c0,0,0,0,0.4,0 C727.4,379.2,752.9,433,746.6,487.6L746.6,487.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.9c3398488ca812b3e14f7b3842039122.svg";
export { ForwardRef as ReactComponent };